import { render, staticRenderFns } from "./calcVesselsDetail.vue?vue&type=template&id=f07dd01c&scoped=true"
import script from "./calcVesselsDetail.vue?vue&type=script&lang=js"
export * from "./calcVesselsDetail.vue?vue&type=script&lang=js"
import style0 from "./calcVesselsDetail.vue?vue&type=style&index=0&id=f07dd01c&prod&lang=scss"
import style1 from "./calcVesselsDetail.vue?vue&type=style&index=1&id=f07dd01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07dd01c",
  null
  
)

export default component.exports